// removed by extract-text-webpack-plugin
module.exports = {"USSalesTax":"_1aqDVfV"};


//////////////////
// WEBPACK FOOTER
// ./template/components/MiniBag/Footer/SubTotal/USSalesTax/index.css
// module id = ./template/components/MiniBag/Footer/SubTotal/USSalesTax/index.css
// module chunks = client.sitechrome